export default {
    config: {
        defaultWidth: {
            default: 80,
            sheet: 160
        },
    },
    default: {
        label: 'Date'
    },
    unique: [],
    sort: ['play.date', 'played.last', 'played.first', 'date'],
    lang: {
        name: 'Date Played',
        category: ['User', 'Plays'],
        description: 'When the game was played.',
        views: ['list', 'sheet'],
    },
    filters: ['date.played']
}